import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ProjectDetails from '../Pages/Projects/ProjectDetails'
import UserStats from '../Pages/Users/UserStats'
import SprintDetails from '../Pages/Projects/SprintDetails'
import SprintAnalysis from '../Pages/Projects/SprintAnalysis'
import SprintUserAnalysis from '../Pages/Projects/SprintUserAnalysis'
import SprintWinner from '../Pages/Projects/Winner/SprintWinner'
import Projects from '../Pages/Projects/Projects'

const ProjectsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Projects />} />
      <Route path=':projKey' element={<ProjectDetails />} />
      <Route
        path=':projKey/boards/:boardId/sprints/:sprintId/analysis/user/:userId'
        element={<SprintUserAnalysis />}
      />
      <Route
        path=':projKey/boards/:boardId/sprints/:sprintId/winner'
        element={<SprintWinner />}
      />
      <Route
        path=':projKey/boards/:boardId/sprints/:sprintId/analysis'
        element={<SprintAnalysis />}
      />
      <Route
        path=':projKey/boards/:boardId/sprints/:sprintId'
        element={<SprintDetails />}
      />
      {/* Updated project-context user stats route */}
      <Route path=':projKey/users/:userId/stats' element={<UserStats />} />
    </Routes>
  )
}

export default ProjectsRoutes
